import { Classes } from "../../theme/Classes"

export const Text = ({ children, role = "p" }) => {

    return (
        <>
            {role == "alert" &&
                <p style={Classes.Text.Alert} >{children}</p>
            }
            {role == "p" &&
                < p style={Classes.Text.Normal} >{children}</p >
            }
            {role == "h1" &&
                <h1 style={Classes.Text.h1} >{children}</h1>
            }
            {role == "h2" &&
                <h2 style={Classes.Text.h2} >{children}</h2>
            }
            {role == "h3" &&
                <h3 style={Classes.Text.h3} >{children}</h3>
            }
            {role == "h4" &&
                <h4 style={Classes.Text.h4} >{children}</h4>
            }
            {role == "span" &&
                <span style={Classes.Text.Normal} >{children}</span>
            }
            {role == "subtitle" &&
                <p style={Classes.Text.Subtitle} >{children}</p>
            }
            {role == "validationMessage" &&
                < span style={Classes.Text.ValidationMessage} >{children}</span>
            }
        </>
    )
}
